import { faqItems } from '@/mocks/home';

export default function FAQ() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6" id="faq" aria-labelledby="faq-title">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 id="faq-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">关于国产专区和国货选购的常见疑问解答</p>
        </div>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <details key={index} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between p-4 md:p-5 text-base font-heading font-medium text-foreground-900 list-none cursor-pointer">
                <span>{item.question}</span>
                <i className="ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 group-open:rotate-180"></i>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}